import { sizes } from './media';
export const GRID_UNIT = 8;
export const GUTTER = {
    mobile: 2 * GRID_UNIT,
    tablet: 4 * GRID_UNIT,
    desktop: 4 * GRID_UNIT,
};
export const COLUMN_WIDTH = {
    mobile: 43.8,
    tablet: 68.2,
    desktop: 68.2,
};
export const COLUMN_WIDTH_RELATIVE = 8.33;
export const gridWidth = Object.keys(sizes).reduce((interpolations, size) => (Object.assign(Object.assign({}, interpolations), { [size]: columnNum => COLUMN_WIDTH[size] * columnNum + GUTTER[size] * (columnNum - 1) })), {});
//# sourceMappingURL=grid.js.map